module.exports = __webpack_public_path__ + "img/4.658b8fc9.jpg";